import * as React from "react";
import Button from "@mui/material/Button";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogContentText from "@mui/material/DialogContentText";
import DialogTitle from "@mui/material/DialogTitle";
import Skeleton from "@mui/material/Skeleton";
import { Parser } from "html-to-react";
import StartIcon from "@mui/icons-material/PlayArrow";
import ContentUtil from "./../../util/Content";
import ShareIcon from "@mui/icons-material/Share";
import LeaveIcon from "@mui/icons-material/ExitToApp";
import sanitizeHtml from "sanitize-html";
import {
  CommonContent,
  Content,
  ContentKey,
  ButtonTypes,
} from "../../types/Types";
import ApiCommonContent from "./../../services/GenericContent";
import "./styles.scss";
import { GameDetails, UserAccount } from "../../types/Game";

type Props = {
  content: CommonContent[];
  visible: boolean;
  game: GameDetails;
  user: UserAccount;
  onStartGame: () => void;
  onShareGame: () => void;
  onLeaveGame: () => void;
};

export default function StartGameModal(props: Props) {
  const getStartContent = () => {
    let content = ApiCommonContent.getKeyValue(
      props.content,
      props.user.userId === props.game.ownerUserId
        ? ContentKey.START_GAME_DESCRIPTION
        : ContentKey.START_GAME_DESCRIPTION_USER_INVITED
    );
    content = ContentUtil.replacePlaceholder(
      content,
      "{USER_NAME}",
      "<b>" + props.user.name + "</b>"
    );

    content = ContentUtil.replacePlaceholder(
      content,
      "{USER_HAS_INVITED_YOU}",
      "<b>" + props.game.ownerUserName + "</b>"
    );

    return content;
  };
  return (
    <div>
      <Dialog
        open={props.visible}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
      >
        <DialogTitle id="alert-dialog-title" className="backgroundAzul">
          {ApiCommonContent.getKeyValue(props.content, ContentKey.PLEASE_WAIT)}
          ...
          <Skeleton variant="rectangular" width={"100%"} height={15} />
        </DialogTitle>
        <DialogContent className="backgroundAzul" dividers>
          <div className="introTextDialog2">
            {Parser().parse(getStartContent())}
          </div>
        </DialogContent>
        <DialogActions className="backgroundAzul">
          {props.user.userId !== props.game.ownerUserId && (
            <Button
              start-game-modal-button
              onClick={props.onLeaveGame}
              variant="text"
              startIcon={<LeaveIcon />}
            >
              {ApiCommonContent.getKeyValue(
                props.content,
                ContentKey.LEAVE_GAME
              )}
            </Button>
          )}
          {props.user.userId === props.game.ownerUserId && (
            <Button
              onClick={props.onShareGame}
              variant="text"
              startIcon={<ShareIcon />}
            >
              {ApiCommonContent.getKeyValue(
                props.content,
                ContentKey.INVITE_PLAYERS
              )}
            </Button>
          )}
          {props.user.userId === props.game.ownerUserId && (
            <Button
              onClick={props.onStartGame}
              className="start-game-modal-button"
              variant="text"
              startIcon={<StartIcon />}
            >
              {ApiCommonContent.getButtonName(
                props.content,
                ButtonTypes.START_GAME
              )}
            </Button>
          )}
        </DialogActions>
      </Dialog>
    </div>
  );
}
